<template>
  <img src="https://images.qmai.cn/s12416/images/2021/08/02/ba5b4194f2857a4a.png" alt="暂无数据图" />
</template>

<script>
let id = 0
export default {
  name: 'ImgEmpty',
  data() {
    return {
      id: ++id,
    }
  },
}
</script>
